import { jsx as e } from "react/jsx-runtime";
import { useContext as T, useState as C, useEffect as I } from "react";
import { useTranslation as N } from "react-i18next";
import S from "classnames";
import { ThemeContext as b, Switcher as v, Modal as E, Button as z, Edit as A } from "@forma/forma-ui-kit";
import F from "../FillGroup/index.js";
import j from "./FillVariationAnswer/index.js";
const V = "forma-filling__fill-variations__edit", B = "forma-filling__fill-variations__editIcon", G = "forma-filling__fill-variations__switcher", M = "forma-filling__fill-variations__sendingText", o = {
  edit: V,
  editIcon: B,
  switcher: G,
  sendingText: M
}, O = ({
  id: u,
  title: g,
  multiple: p,
  variants: r,
  value: s,
  selected: a,
  onChange: d,
  onSelect: m,
  showSelect: f
}) => {
  const { t: n } = N(), { viewport: x } = T(b), [_, l] = C(!1);
  I(() => {
    s != null && s.length || l(!0);
  }, [s]);
  const k = (i, c) => {
    let t = [...s];
    if (p)
      if (c)
        t.push(i);
      else {
        const h = t.findIndex((y) => y === i);
        h !== -1 && t.splice(h, 1);
      }
    else
      t = [i];
    d(t), l(!1);
  }, w = () => {
    setTimeout(() => {
      d([]), l(!0);
    }, 0);
  };
  return /* @__PURE__ */ e(
    F,
    {
      title: g,
      buttons: f && m && /* @__PURE__ */ e(
        v,
        {
          containerClass: o.switcher,
          name: `checkbox_${u}`,
          label: x !== "phone" && n("uikit:select_block"),
          size: "small",
          onChange: (i) => m(i.target.checked),
          checked: a
        }
      ),
      children: f && a ? /* @__PURE__ */ e("div", { className: o.content, children: /* @__PURE__ */ e("div", { className: o.sendingText, children: n("uikit:sending_to_filling") }) }) : /* @__PURE__ */ e("div", { className: S(_ && o.content), children: _ ? r.map(({ id: i, key: c, value: t }) => /* @__PURE__ */ e(
        j,
        {
          id: i,
          name: c,
          description: t,
          selected: t.includes(i),
          onSelect: k
        },
        i
      )) : /* @__PURE__ */ e(
        E,
        {
          title: n("uikit:do_you_want_change_your_choice"),
          control: /* @__PURE__ */ e(
            z,
            {
              viewStyle: "secondary",
              size: "extraSmall",
              className: o.edit,
              iconClassName: o.editIcon,
              icon: /* @__PURE__ */ e(A, {}),
              title: n("uikit:edit"),
              children: r.filter(({ id: i }) => s.includes(i)).map(({ key: i }) => i).join(", ")
            }
          ),
          buttons: [
            {
              children: n("uikit:yes_change"),
              viewStyle: "tertiary",
              onClick: w
            },
            {
              children: n("uikit:cancel"),
              viewStyle: "tertiary"
            }
          ],
          size: "small",
          children: /* @__PURE__ */ e("div", { style: { textAlign: "center" }, children: n("uikit:variation_anser_change_notice") })
        }
      ) })
    }
  );
};
export {
  O as default
};
